export const ListGuide = [
    {
        topic: 'Onboarding',
        steps: [
            {
                title: 'Information',
                image: './assets/images/guide/Information.png',
                content: 'Enter your phone number and nationID'
            },
            {
                title: 'eKYC',
                image: './assets/images/guide/eKYC.png',
                content: 'Upload image to eKYC your information and check face match'
            },
            {
                title: 'Product',
                image: './assets/images/guide/Product.png',
                content: 'Choose your type card you want to create'
            },
            {
                title: 'Confirmation',
                image: './assets/images/guide/Confirmation.png',
                content: 'Confirm your information to open card'
            },
            {
                title: 'Address',
                image: './assets/images/guide/Address.png',
                content: 'Enter your address to receive your card'
            },
            {
                title: 'Contract',
                image: './assets/images/guide/Contract.png',
                content: 'Assign to contract to create data in Way4'
            }
        ]
    },
    {
        topic: 'Open contract',
        steps: [
            {
                title: 'Product',
                image: './assets/images/guide/ProductContract.png',
                content: 'Choose your type card you want to create'
            },
            {
                title: 'Confirmation',
                image: './assets/images/guide/ConfirmContract.png',
                content: 'Confirm your information to open card'
            },
            {
                title: 'Contract',
                image: './assets/images/guide/ContractContract.png',
                content: 'Assign to contract to create data in Way4'
            }
        ]
    },
    {
        topic: 'Transfer',
        steps: [
            {
                title: 'Choose Contract',
                image: './assets/images/guide/ChooseContract.png',
                content: 'Choose one of your contracts to transfer'
            },
            {
                title: 'Input Information',
                image: './assets/images/guide/CompleteInformation.png',
                content: 'Enter your partner s information'
            },
            {
                title: 'Verify OTP',
                image: './assets/images/guide/VerifyOTP.png',
                content: 'Verify OTP sent your phone number or your Google Authenticatior App'
            },
            {
                title: 'Transaction History',
                image: './assets/images/guide/TransactionHistory.png',
                content: 'Check your transaction history'
            }
            
        ]
    }
]